/**
 * Switch Component Renderer
 *
 * Renders switch components with proper prop spreading and validation.
 *
 * @since 6.9.0 Initial implementation
 */
import { html } from 'lit';
import { spreadProps } from '../utils/spread-props';
/**
 * Allowed props for uo-field-input-switch component
 */
const uoFieldInputSwitchAllowedProps = new Set([
    'id',
    'name',
    'checked',
    'disabled',
    'loading',
    'label-on',
    'label-off',
    'size',
    'label-placement',
    'required'
]);
/**
 * Render a switch component
 *
 * @param {SwitchData} data - The switch data to render
 * @param {ComponentProps} [props={}] - Additional props to spread
 *
 * @return {TemplateResult} The rendered switch component
 */
export function switchRenderer(data, props = {}) {
    return html `
		<uo-field-input-switch 
			${spreadProps(uoFieldInputSwitchAllowedProps)({ ...data, ...props })}
		>
		</uo-field-input-switch>
	`;
}
